export default async function getMenuData() {
  return [
    {
      category: true,
      title: 'Apps & Pages',
    },
    {
      title: 'Apps',
      key: 'apps',
      icon: 'fe fe-home',
      // roles: ['admin'], // set user roles with access to this route
      count: 2,
      children: [
        {
          title: 'Main Page',
          key: 'mainPage',
          url: '/apps/main',
        },
        {
          title: 'Second Page',
          key: 'secondPage',
          url: '/apps/second',
        },
      ],
    },
  ]
}
